import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { RxStateComponent } from '@alliance/shared/models'
import { ClubTag } from '@alliance/clubs/domain'

@Component({
  selector: 'alliance-clubs-tags-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagsListComponent extends RxStateComponent<{
  tags: ClubTag[]
}> {
  public state = this.connectViewState(['tags'])

  public constructor() {
    super()

    this.initState({
      tags: []
    })
  }

  @Input()
  public set tags(value: ClubTag[]) {
    this.set({ tags: value })
  }

  public trackByFn(index: number): number {
    return index
  }
}
